import axios from "axios";
import authHeader from "../../Services/auth-header";
import { refreshToken } from "../../Services/auth.service";
import { baseURLDeleteFile } from "../../Services/client";

export function createDeleteUploadedPdf({
  uploadedPDFFile,
  uploadedPDFURL,
  setUploadedPDFURL,
  setUploadedPDFFile,
  setUploadedPDFNameList,
  setDeleteUploadImageUrl,
  setDeleteUploadImageIndex,
}) {
  return function deleteUploadedPdf(uploadedPdfsNamesList1, fileUrl, index) {
    let promise2 = new Promise((resolve, reject) => {
      if (fileUrl !== "") {
        axios
          .delete(baseURLDeleteFile, {
            params: {
              url: fileUrl,
            },
            headers: authHeader(),
          })
          .then((response) => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  deleteUploadedPdf(uploadedPdfsNamesList1, fileUrl, index);
                  reject();
                } else {
                  resolve();
                }
              });
            } else {
              resolve();
            }
          });
      } else {
        resolve();
      }
    });
    promise2.then(() => {
      let tempArrayNames = [...uploadedPdfsNamesList1];
      let tempArrayFiles = [...uploadedPDFFile];
      let tempArrayURLs = [...uploadedPDFURL];

      delete tempArrayNames[index];
      delete tempArrayFiles[index];
      delete tempArrayURLs[index];

      setUploadedPDFURL(tempArrayURLs);
      setUploadedPDFFile(tempArrayFiles);
      setUploadedPDFNameList(tempArrayNames);
      setDeleteUploadImageUrl("");
      setDeleteUploadImageIndex(-1);
    });
  };
}
